export default {
  methods: {
    accountTypeByCode (code) {
      switch (code) {
        case 'B':
          return 'Broker'
        case 'C':
          return 'Client'
        case 'T':
          return 'TPA'
        case 'R':
          return 'Reseller'
        default:
          return ''
      }
    }
  }
}
